import { render, staticRenderFns } from "./select-model.vue?vue&type=template&id=9a2509a6"
import script from "./select-model.vue?vue&type=script&lang=js"
export * from "./select-model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports